const GCLID_KEY = "tidyrota.gclid";

function safeStorage(): Storage | null {
  if (typeof window === "undefined") return null;
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function storeGclid(gclid: string): void {
  const storage = safeStorage();
  if (!storage) return;
  try {
    storage.setItem(GCLID_KEY, gclid);
  } catch {
    // Storage quota exceeded or disabled. Attribution is best-effort.
  }
}

export function getStoredGclid(): string | null {
  const storage = safeStorage();
  if (!storage) return null;
  try {
    return storage.getItem(GCLID_KEY);
  } catch {
    return null;
  }
}

export function captureGclidFromUrl(): void {
  if (typeof window === "undefined") return;
  const gclid = new URLSearchParams(window.location.search).get("gclid");
  if (gclid) {
    storeGclid(gclid);
  }
}
